<button style="float:right;" class="btn btn-primary" type="button" mdbBtn rounded="true" data-toggle="modal"
  data-target="#basicExample" (click)="frame.show()" mdbWavesEffect>
  {{ 'texto_60' | translate }}
</button>

<div mdbModal #frame="mdbModal" class="modal fade top" id="frameModalTop" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">

  <div class="modal-dialog cascading-modal modal-avatar modal-sm" role="document">
    <div class="modal-content">

      <div class="modal-body mx-3" style="padding-right: 1rem; padding-left: 1rem;">
        <div class="card-header card-header-info">
          <h5 class="card-title mb-0">{{ 'texto_673' | translate }}</h5>
        </div>

        <button type="button" class="btn btn-dark" style="z-index:100; float: right; margin-top: -2.8rem;"
          data-dismiss="modal" (click)="frame.hide()" aria-label="Cerrar modal">X</button>

        <!-- ID Centro -->
        <div class="md-form mb-3">
          <input type="number" id="orangeForm-email" class="form-control" [formControl]="signupFormModalId" mdbInput
            mdbValidate>
          <label for="orangeForm-email">ID. {{ 'texto_672' | translate }}</label>
          <mdb-error *ngIf="signupFormModalId.invalid && (signupFormModalId.dirty || signupFormModalId.touched)">
            {{ 'texto_61' | translate }}
          </mdb-error>
          <mdb-success *ngIf="signupFormModalId.valid && (signupFormModalId.dirty || signupFormModalId.touched)">
            {{ 'texto_62' | translate }}
          </mdb-success>
        </div>

        <!-- Nombre del Centro -->
        <div class="md-form mb-3">
          <input type="text" id="orangeForm-name" class="form-control" [formControl]="signupFormModalName" mdbInput
            mdbValidate maxlength="255">
          <label for="orangeForm-name">{{ 'texto_675' | translate }}</label>
          <mdb-error *ngIf="signupFormModalName.invalid && (signupFormModalName.dirty || signupFormModalName.touched)">
            {{ 'texto_61' | translate }}
          </mdb-error>
          <mdb-success *ngIf="signupFormModalName.valid && (signupFormModalName.dirty || signupFormModalName.touched)">
            {{ 'texto_62' | translate }}
          </mdb-success>
        </div>

        <!-- Empresa -->
        <div class="md-form mb-3">
          <label for="orangeForm-empresa">ID. {{ 'texto_67' | translate }}</label><br>
          <mat-form-field>
            <mat-select [formControl]="signupFormModalidEmpresa">
              <mat-option *ngFor="let empresa of empresas" [value]="empresa.id_empresa">
                {{ empresa.n_empresa }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mdb-error
            *ngIf="signupFormModalidEmpresa.invalid && (signupFormModalidEmpresa.dirty || signupFormModalidEmpresa.touched)">
            {{ 'texto_61' | translate }}
          </mdb-error>
          <mdb-success
            *ngIf="signupFormModalidEmpresa.valid && (signupFormModalidEmpresa.dirty || signupFormModalidEmpresa.touched)">
            {{ 'texto_62' | translate }}
          </mdb-success>
          <br>
        </div>

        <!-- Comentarios -->
        <div class="md-form">
          <label for="form107">{{ 'texto_46' | translate }}</label>
          <mdb-icon fas icon="pencil-alt" class="prefix grey-text" style="margin-top: 10%;"></mdb-icon>
          <textarea maxlength="4000" type="text" id="form107" class="md-textarea form-control" rows="5" mdbInput
            [formControl]="contactFormModalMessage">
          </textarea>
          <mdb-error
            *ngIf="contactFormModalMessage.invalid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
            {{ 'texto_61' | translate }}
          </mdb-error>
          <mdb-success
            *ngIf="contactFormModalMessage.valid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
            {{ 'texto_62' | translate }}
          </mdb-success>
        </div>
      </div>

      <!-- Botón para agregar centro -->
      <div class="text-center mt-3">
        <button (click)="addCenter()" mdbBtn rounded="true" class="btn-primary mt-1 waves-light" mdbWavesEffect>
          {{ 'texto_60' | translate }}
        </button>
      </div>

    </div>
  </div>
</div>
